import React from 'react';
import cn from 'classnames';
import { ProgressBarEnum } from '../../types';
import styles from './stepper-form.module.css';
export var StepsIndicator = React.memo(function (_ref) {
  var progressBar = _ref.progressBar,
    currentStepIndex = _ref.currentStepIndex,
    stepsLength = _ref.stepsLength,
    background = _ref.background;
  if (progressBar === ProgressBarEnum.LinearBar) {
    return React.createElement("div", {
      className: cn(styles["background-".concat(background)])
    }, React.createElement(ProgressBar, {
      width: currentStepIndex / (stepsLength || 1) * 100
    }));
  }
  if (progressBar === ProgressBarEnum.Steps) {
    return React.createElement("div", {
      className: styles.numSteps
    }, "\u0448\u0430\u0433 ".concat(currentStepIndex + 1, "/").concat(stepsLength));
  }
  return null;
});
var ProgressBar = function ProgressBar(_ref2) {
  var width = _ref2.width;
  return React.createElement("div", {
    className: styles.progressBarContainer
  }, React.createElement("div", {
    className: styles.progress,
    style: {
      right: "".concat((100 - width).toFixed(2), "%")
    }
  }));
};